(function () {
  function initCameliaHero(root) {
    if (!root || root.dataset.cameliaInit === 'true') return;
    root.dataset.cameliaInit = 'true';

    var magnifier = root.querySelector('[data-camelia-magnifier]');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var pulsed = false;

    if (magnifier && 'IntersectionObserver' in window) {
      var pulseObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !pulsed && !reducedMotion) {
            pulsed = true;
            magnifier.classList.add('camelia-hero__magnifier--pulse');
            magnifier.addEventListener('animationend', function handler() {
              magnifier.classList.remove('camelia-hero__magnifier--pulse');
              magnifier.removeEventListener('animationend', handler);
            });
          }
        });
      }, { threshold: 0.6 });
      pulseObserver.observe(magnifier);
    }

    if (magnifier) {
      magnifier.addEventListener('click', function () {
        var expanded = root.getAttribute('data-camelia-state') === 'expanded';
        root.setAttribute('data-camelia-state', expanded ? '' : 'expanded');
        magnifier.setAttribute('aria-pressed', expanded ? 'false' : 'true');

        if (!expanded) {
          var nextSection = document.querySelector('[data-camelia-education-story]');
          if (nextSection) {
            window.setTimeout(function () {
              nextSection.scrollIntoView({
                behavior: reducedMotion ? 'auto' : 'smooth',
                block: 'start'
              });
            }, reducedMotion ? 0 : 1000);
          }
        }
      });
    }
  }

  function initAll(rootDoc) {
    rootDoc.querySelectorAll('[data-camelia-hero]').forEach(initCameliaHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
